import React from "react";
import { Link } from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";
import usePageContext from "context/PageContext";
import useUI from "context/UIContext";
import PropTypes from "prop-types";

export const LocalizedLink = ({ to, ...rest }) => {
  const { lang } = usePageContext();
  const { navOnClose } = useUI();

  return (
    <Link
      // pointerEvents="none" /* Disable pointer events */
      // userSelect="none" /* Prevent accidental text selection */
      // draggable="false"
      /* Disable default browser drag behavior */
      as={GatsbyLink}
      onClick={navOnClose}
      to={`/${lang}${to}`}
      {...rest}
    />
  );
};

LocalizedLink.propTypes = {
  to: PropTypes.string.isRequired,
};
